module.exports = __webpack_public_path__ + "media/images/error-19ee6b7e.svg";